import { ProfilePrompts } from '@/screens/profile-prompts';

export default function ProfilePromptsScreen() {
  return <ProfilePrompts />;
}
